import * as Scrivito from 'scrivito';
import { TrafficInfoWidgetClass } from './traffic-info-widget-class';
import { useTrafficInfoApi } from './traffic-info-api';
import { TrafficInfoContextProvider } from './traffic-info-context';
import { TrafficInfoFilter } from './components/traffic-info-filter';
import { TrafficInfoList } from './components/traffic-info-list';
import { TrafficInfoWidgetAttributes } from './traffic-info-widget-definitions';
import { TrafficInfoResponse } from './traffic-info-types';
import dummyData from './traffic-info-widget-dummy.json';
import dummyAreaInfo from './traffic-info-widget-dummy-area.json';
import { TrafficInfoAreaInfos } from './components/traffic-info-area-infos';
import { spacingClassName } from '../../utils/scrivito/spacing-definitions';

interface TrafficInfoWidgetComponentProps {
  data: TrafficInfoResponse;
}

export const TrafficInfoWidgetComponent = ({ data }: TrafficInfoWidgetComponentProps): JSX.Element => {
  return (
    <TrafficInfoContextProvider lines={data.infos}>
      <div>
        <TrafficInfoAreaInfos data={data} />
        <TrafficInfoFilter data={data} />
        <TrafficInfoList />
      </div>
    </TrafficInfoContextProvider>
  );
};

export const TrafficInfoWidgetFetcher = (): JSX.Element => {
  const { data, isLoading, error } = useTrafficInfoApi();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  return <TrafficInfoWidgetComponent data={data} />;
};

export const TrafficInfoWidgetDummy = (props: { withAreaInfo: boolean }): JSX.Element => {
  let data: TrafficInfoResponse = dummyData as TrafficInfoResponse;
  if (props.withAreaInfo) {
    data = Object.assign({}, data, { areaInfos: [dummyAreaInfo] });
  }

  return <TrafficInfoWidgetComponent data={data} />;
};

export const TrafficInfoWidget = ({ widget }: Scrivito.WidgetComponentProps): JSX.Element => {
  const shouldUseDummyData = widget.get(TrafficInfoWidgetAttributes.DUMMY_DATA) as boolean;
  const shouldUseDummyAreaInfo = widget.get(TrafficInfoWidgetAttributes.DUMMY_AREA_INFO) as boolean;

  return (
    <Scrivito.WidgetTag>
      <div className={spacingClassName(widget)}>
        {shouldUseDummyData ? (
          <TrafficInfoWidgetDummy withAreaInfo={shouldUseDummyAreaInfo} />
        ) : (
          <TrafficInfoWidgetFetcher />
        )}
      </div>
    </Scrivito.WidgetTag>
  );
};

Scrivito.provideComponent(TrafficInfoWidgetClass, TrafficInfoWidget);
